import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { formatBiography } from './biographyFormatter';
import {
    Editor,
    EditorProvider,
    Toolbar,
    BtnBold,
    BtnItalic,
    BtnUnderline,
    BtnNumberedList,
    BtnBulletList,
    BtnLink
} from "react-simple-wysiwyg";
import { toast } from "react-toastify";
import { fetchAuthorById, addAuthor, updateAuthor } from '../../apiCalls';
export default function AddorEditAuthor() {

    const { id } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();

    const isEditMode = !!id;

    const [author, setAuthor] = useState(
        state?.author || {
            author_name: '',
            pen_name: '',
            author_phone: '',
            author_email: '',
            biography: "",
            address: "",
            photo: ''
        }
    );

    const [photoPreview, setPhotoPreview] = useState(
        state?.author?.photo
            ? `https://api.uyirmozhy.in/assets/images/authors/${state.author.photo}`
            : null
    );

    const [loading, setLoading] = useState(false);

    //////////////////////////////////////////////////
    // Fetch author if edit and no state
    useEffect(() => {
        if (isEditMode && !state?.author) {
            fetchAuthor();
        }
    }, [id]);

    const fetchAuthor = async () => {
        try {
            const res = await fetchAuthorById(id);
            setAuthor(res);

            if (res.photo) {
                setPhotoPreview(
                    `https://api.uyirmozhy.in/assets/images/authors/${res.photo}`
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    //////////////////////////////////////////////////
    // Input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAuthor(prev => ({ ...prev, [name]: value }));
    };

    //////////////////////////////////////////////////
    // Photo change
    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAuthor(prev => ({ ...prev, photo: file }));
            setPhotoPreview(URL.createObjectURL(file));
        }
    };

    //////////////////////////////////////////////////
    // Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formData = new FormData();
            const formattedBiography = formatBiography(author.biography);

            Object.keys(author).forEach(key => {
                if (key === "biography") {
                    formData.append("biography", formattedBiography);
                } else {
                    formData.append(key, author[key]);
                }
            });


            if (isEditMode) {
                await updateAuthor(id, formData);
                toast.success("Author updated successfully.");
            } else {
                await addAuthor(formData);
                toast.success("Author added successfully.");
            }

            navigate("/authors");

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='page-title-container'>
                <h2>
                    {isEditMode ? "Edit Author" : "Add Author"}
                    <span>
                        {isEditMode
                            ? "Update author details"
                            : "Create a new author"
                        }
                    </span>
                </h2>
            </div>

            <div className="container mt-4">
                <form onSubmit={handleSubmit}>

                    {/* Author Name */}
                    <div className="mb-3">
                        <label className="form-label">Name of Author</label>
                        <input
                            type="text"
                            className="form-control"
                            name="author_name"
                            value={author.author_name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Pen Name */}
                    <div className="mb-3">
                        <label className="form-label">Pen Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="pen_name"
                            value={author.pen_name}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Phone */}
                    <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <input
                            type="text"
                            className="form-control"
                            name="author_phone"
                            value={author.author_phone}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Email */}
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            name="author_email"
                            value={author.author_email}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Photo */}
                    <div className="mb-3">
                        <label className="form-label">Photo</label>
                        <input
                            type="file"
                            className="form-control"
                            onChange={handlePhotoChange}
                        />
                        {photoPreview && (
                            <div className="mt-3">
                                <img
                                    src={photoPreview}
                                    alt="preview"
                                    width="120"
                                    style={{ borderRadius: "8px" }}
                                />
                            </div>
                        )}
                    </div>

                    {/* Biography with react-simple-wysiwyg */}
                    <div className="mb-3">
                        <label className="form-label">Biography</label>
                        <EditorProvider>
                            <Toolbar>
                                <BtnBold />
                                <BtnItalic />
                                <BtnUnderline />
                                <BtnNumberedList />
                                <BtnBulletList />
                                <BtnLink />
                            </Toolbar>

                            <Editor
                                value={author.biography || ""}
                                onChange={(e) =>
                                    setAuthor(prev => ({
                                        ...prev,
                                        biography: e.target.value
                                    }))
                                }
                            />
                        </EditorProvider>
                    </div>

                    {/* Address */}
                    <div className="mb-3">
                        <label className="form-label">Address</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            name="address"
                            value={author.address}
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="btn btn-secondary btn-sm save-btn"
                        disabled={loading}
                    >
                        {loading
                            ? "Please wait..."
                            : isEditMode
                                ? "Update Author"
                                : "Add Author"
                        }
                    </button>

                </form>
            </div>
        </>
    );
}